// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"fa74fa59","478":"c8edb708"}[chunkId] + ".chunk.css";
};